import React from "react";
import ReactTable from "react-table";

const RSheetsList = (props) => {
    const { columns, data, hiddenColumns } = props;
    const defaultSorted = props.defaultSorted
        ? props.defaultSorted
        : [
              {
                  id: "date",
                  desc: true,
              },
          ];

    const visibleColumns = Array.isArray(hiddenColumns) && hiddenColumns.length > 0
        ? columns.filter(c => hiddenColumns.indexOf(c.accessor) === -1)
        : columns;

    return (
        <div className="react-table-hover-gray">
            <ReactTable
                defaultSorted={defaultSorted}
                data={data}
                className="-striped"
                showPaginationTop
                showPaginationBottom
                columns={visibleColumns}
                resizable
                defaultPageSize={10}
                pageSizeOptions={[10, 20, 30]}
                minRows={10}
                filterable
                getTdProps={props.getTdProps}
            />
        </div>
    );
};

export default RSheetsList;
